// CourseCard.js
import React, { useEffect } from "react";
import "./CourseCard.css";

import img1 from "../../Assets/WhatsApp Image 2024-09-24 at 09.12.47_098db80c.jpg";
import img2 from "../../Assets/WhatsApp Image 2024-09-24 at 09.12.57_f6113d2d.jpg";
import img3 from "../../Assets/WhatsApp Image 2024-09-02 at 15.39.49_baf337a4.jpg";
import img4 from "../../Assets/WhatsApp Image 2024-09-24 at 09.20.01_1e2a72a7.jpg";
import img5 from "../../Assets/WhatsApp Image 2024-09-24 at 09.18.19_0694184e.jpg";
import img6 from "../../Assets/WhatsApp Image 2024-09-23 at 14.27.21_0ce2a35f.jpg";
import { Link } from "react-router-dom";
import AOS from "aos";
// Example images
// const images = [

// ];

const CourseCard = () => {
  const courses = [
    {
      id: 1,
      title: "Basic Noorani Qaida",
      image: `${img1}`,
      link: "/Noorani-Qaida",
    },
    {
      id: 2,
      title: "Online Quran Reciation",
      image: `${img2}`,
      link: "/OnlineQuranRecitation",
    },
    {
      id: 3,
      title: "Quran with Tajweed",
      image: `${img3}`,
      link: "/Quran-with-Tajweed",
    },
    {
      id: 4,
      title: "Memorization of Holy Quran",
      image: `${img4}`,
      link: "/Online-Quran-Memorization",
    },
    {
      id: 5,
      title: "Tafseer",
      image: `${img5}`,
      link: "/Tafseer",
    },
    {
      id: 6,
      title: "Quran Translation",
      image: `${img6}`,
      link: "/Quran-Translation",
    },
  ];
  useEffect(() => {
    AOS.init({
      duration: 3000,
    });
  });

  return (
    <>
      <h2 className="text-center  container-title container mt-5">
        Our Popular Courses
      </h2>
      <div className="course-cards-grid container">
        {courses.map((course) => (
          <div className="course-card" key={course.id} data-aos="zoom-in">
            <img
              src={course.image}
              alt={course.title}
              className="course-image"
            />
            <h3 className="course-title-">{course.title}</h3>
            <Link to={course.link} className="course-link">
              Learn More
            </Link>
          </div>
        ))}
      </div>
    </>
  );
};

export default CourseCard;
